import React, { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Navbar from "../component/navbar/Navbar";
import Logo from "./Logo";
import AuthNav from "../component/authentication/AuthNav";
import ToggleDarkMode from "./ToggleDarkMode";

gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  const [theme, setTheme] = useState("dark");
  const headerRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem("theme") === null) {
      localStorage.setItem("theme", "dark");
    }
  }, []);

  useEffect(() => {
    const html = document.querySelector("html");
    if (localStorage.getItem("theme") === "dark") {
      html.classList.add("dark");
      setTheme("dark");
    } else {
      html.classList.remove("dark");
      setTheme("light");
    }
  }, [theme]);

  const handleTheme = () => {
    if (localStorage.getItem("theme") === "dark") {
      localStorage.setItem("theme", "light");
      setTheme("light");
    } else {
      localStorage.setItem("theme", "dark");
      setTheme("dark");
    }
  };

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "+=200",
        scrub: 1,
      },
    });

    tl.fromTo(
      headerRef.current,
      {
        width: "90%",
        top: "20px",
        borderRadius: "50px",
        backgroundColor: "var(--header-bg-start)",
        border: "1px solid var(--header-border)",
        boxShadow: "var(--header-shadow)",
      },
      {
        width: "100%",
        top: "0px",
        borderRadius: "0px",
        backgroundColor: "var(--header-bg-end)",
        border: "0px solid transparent",
        borderBottom: "1px solid var(--header-border)",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(12px)",
      }
    );
  }, { dependencies: [theme] });

  return (
    <header
      ref={headerRef}
      className="fixed z-50 left-1/2 -translate-x-1/2 backdrop-blur-md transition-all duration-300 font-primary text-gray-600 dark:text-lightText"
    >
      <div className="container mx-auto flex h-16 sm:h-20 items-center justify-between px-3 sm:px-6 lg:px-8 py-1 sm:py-2">
        <div className="flex items-center gap-2 sm:gap-4">
          <Logo />
          <div className="scale-75 sm:scale-100 origin-left">
             <ToggleDarkMode handleTheme={handleTheme} />
          </div>
        </div>
        <div className="flex items-center gap-1 sm:gap-4">
           <Navbar />
           <div className="scale-90 sm:scale-100">
              <AuthNav />
           </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
